import { ThemeProvider } from "@fprint/ui";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { SiteGate } from "./components/SiteGate";
import { brand } from "./lib/brand";
import { AuthProvider } from "./lib/auth";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <SiteGate>
      <ThemeProvider brand={brand}>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </SiteGate>
  </StrictMode>,
);
